export const ProjectsEmpty = {
    projectsForClientMain: "案件の登録がありません。",
    projectsForClientDescription: "案件を掲載することで、登録者とのやり取りが開始できます。",

    projectsForClientScoutMain: "公開設定の案件がありません。",
    projectsForClientScoutDescription: "スカウトしたいプロに案件を提示する必要があります。",

    projectsForCustomerMain: "該当する案件がありません。",
    projectsForCustomerDescription: "条件を変更して検索してください。",

    projectsForCustomerEntriesMain: "エントリー履歴がありません。",
    projectsForCustomerEntriesDescription: "",
    projectsForCustomerEntriesBtnText: "案件をみる",
};


// WEBPACK FOOTER //
// ./src/config/view_const/projects.ts